import React from 'react';
import {PropTypes} from 'prop-types';
import {Card, Heading, Box, Button} from '@spothero/ui';
import DatePicker from './DatePicker';
import TimePicker from './TimePicker';
import {formatDateForURL} from '../../utils/format-utils';
import dayjs from 'dayjs';

import {
    DateTimePickerStyleProps,
    InputGroupStyleProps,
    buttonStyleProps,
    ButtonContainerStyleProps,
} from './DateTimePickerStyleProps';

function DateTimePicker({
    destinationId,
    selectedStartDate,
    setSelectedStartDate,
    selectedStartTime,
    setSelectedStartTime,
    selectedEndDate,
    setSelectedEndDate,
    selectedEndTime,
    setSelectedEndTime,
}) {
    return (
        <Card {...DateTimePickerStyleProps} width="100%">
            <Heading as="h3">Find Parking</Heading>

            <Box {...InputGroupStyleProps}>
                <DatePicker
                    setSelectedDate={setSelectedStartDate}
                    selectedDate={selectedStartDate}
                    pickerProps={null}
                    disabled={false}
                    inputStyleProps={null}
                    labelText="Enter After"
                    minDate={dayjs().startOf('day').toDate()}
                />
                <TimePicker
                    time={selectedStartTime}
                    setTime={setSelectedStartTime}
                    minimumTime="00:00:00"
                    disabled={false}
                />
            </Box>
            <Box {...InputGroupStyleProps}>
                <DatePicker
                    setSelectedDate={setSelectedEndDate}
                    selectedDate={selectedEndDate}
                    pickerProps={null}
                    disabled={false}
                    inputStyleProps={null}
                    labelText="Exit Before"
                    minDate={dayjs(selectedStartDate).startOf('day').toDate()}
                />
                <TimePicker
                    time={selectedEndTime}
                    setTime={setSelectedEndTime}
                    minimumTime="00:00:00"
                    disabled={false}
                />
            </Box>
            <Box {...ButtonContainerStyleProps}>
                <Button
                    as="a"
                    href={`https://spothero.com/search?kind=destination&id=${destinationId}&view=dl&starts=${formatDateForURL(
                        selectedStartDate
                    )}T${selectedStartTime.slice(
                        0,
                        -3
                    )}&ends=${formatDateForURL(
                        selectedEndDate
                    )}T${selectedEndTime.slice(0, -3)}`}
                    target="_parent"
                    {...buttonStyleProps}
                    aria-label="View Details"
                >
                    Find Parking
                </Button>
            </Box>
        </Card>
    );
}

DateTimePicker.propTypes = {
    destinationId: PropTypes.number.isRequired,
    selectedStartDate: PropTypes.object.isRequired,
    setSelectedStartDate: PropTypes.func.isRequired,
    selectedStartTime: PropTypes.string.isRequired,
    setSelectedStartTime: PropTypes.func.isRequired,
    selectedEndDate: PropTypes.object.isRequired,
    setSelectedEndDate: PropTypes.func.isRequired,
    selectedEndTime: PropTypes.string.isRequired,
    setSelectedEndTime: PropTypes.func.isRequired,
};
export default DateTimePicker;
